var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var ScoutingLabelsController = (function () {
    function ScoutingLabelsController(ScoutingLabelsResource, $filter, $uibModal) {
        this.ScoutingLabelsResource = ScoutingLabelsResource;
        this.$filter = $filter;
        this.$uibModal = $uibModal;
    }
    ScoutingLabelsController.prototype.removeLabel = function (label) {
        return __awaiter(this, void 0, void 0, function () {
            var labelName, modalTitle, confirmationText, modalInstance, result, idx, _e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        labelName = label.label.name;
                        modalTitle = 'Remove from List';
                        confirmationText = this.$filter('translate')('scouting.Delete_list_confirmation', {
                            listName: labelName,
                        });
                        modalInstance = this.$uibModal.open({
                            size: 'md',
                            template: "\n        <div class=\"sc-modal\">\n          <div class=\"modal-header\">\n            <h3 class=\"modal-title\">".concat(modalTitle, "</h3>\n          </div>\n          <div class=\"modal-body md-body-1\">\n            <strong>").concat(confirmationText, "</strong>\n          </div>\n          <div class=\"modal-footer\">\n            <div layout layout-align=\"space-between center\" class=\"m-n\">\n              <md-button class=\"md-raised\" ng-click=\"$ctrl.cancel()\">\n                Cancel\n              </md-button>\n              <md-button class=\"md-primary md-raised\" ng-click=\"$ctrl.confirm()\">\n                Remove\n              </md-button>\n            </div>\n          </div>\n        </div>\n      "),
                            controller: [
                                '$uibModalInstance',
                                function ($uibModalInstance) {
                                    this.modalInstance = $uibModalInstance;
                                    this.cancel = function () {
                                        $uibModalInstance.dismiss('cancel');
                                    };
                                    this.confirm = function () {
                                        $uibModalInstance.close('confirm');
                                    };
                                },
                            ],
                            controllerAs: '$ctrl',
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        return [4, modalInstance.result];
                    case 2:
                        result = _a.sent();
                        if (!(result === 'confirm')) return [3, 4];
                        idx = this.labelsHolder.labels.indexOf(label);
                        if (idx >= 0) {
                            this.labelsHolder.labels.splice(idx, 1);
                        }
                        return [4, this.ScoutingLabelsResource.removePlayers({ id: label._id }, { players: [{ _id: this.playerId }] }).$promise];
                    case 3:
                        _a.sent();
                        if (this.onUpdateTable) {
                            this.onUpdateTable();
                        }
                        _a.label = 4;
                    case 4: return [3, 6];
                    case 5:
                        _e_1 = _a.sent();
                        return [3, 6];
                    case 6: return [2];
                }
            });
        });
    };
    return ScoutingLabelsController;
}());
angular.module('app.scouting').component('scoutingLabels', {
    templateUrl: 'scouting/components/general/labels.html',
    controller: ScoutingLabelsController,
    bindings: {
        labelsHolder: '<',
        playerId: '<',
        onUpdateTable: '&',
    },
});